import { Navigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Spinner } from '@shared/ui';
import { ROUTES } from '@shared/config/routes';
import { useBuyRequestQuery, canSubmitAgainst } from '@entities/rfq';
import { BuyRequestDetail } from '@features/rfq-detail';
import { QuoteForm } from '@features/quote-respond';

export function RespondPage() {
  const { id } = useParams<{ id: string }>();
  if (!id) return <Navigate to={ROUTES.buyRequests} replace />;
  return <RespondPageBody id={id} />;
}

function RespondPageBody({ id }: { id: string }) {
  const { t } = useTranslation();
  const rfqQuery = useBuyRequestQuery(id);

  return (
    <div className="flex flex-col gap-6">
      <header>
        <h1 className="text-2xl font-semibold">{t('buyRequests.respond.title')}</h1>
        <p className="text-sm opacity-70">{t('buyRequests.respond.subtitle')}</p>
      </header>

      <BuyRequestDetail id={id} variant="embed" />

      {rfqQuery.isLoading ? (
        <div className="flex justify-center py-6">
          <Spinner />
        </div>
      ) : rfqQuery.data ? (
        canSubmitAgainst(rfqQuery.data) ? (
          <QuoteForm buyRequestId={id} />
        ) : (
          <div className="rounded-md border bg-muted/30 p-4 text-sm opacity-70">
            {rfqQuery.data.alreadyQuoted
              ? t('buyRequests.respond.alreadyResponded')
              : t('buyRequests.respond.notAccepting')}
          </div>
        )
      ) : null}
    </div>
  );
}
